export default {
  data() {
    return {
      schoolSelectData: {},
    };
  },
};
